/**
 * Utility to track order sources (UTMs, Referrer)
 */

export interface SourceData {
  source?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  referrer?: string;
}

const STORAGE_KEY = 'shopstag_source_data';

export function captureSourceData() {
  if (typeof window === 'undefined') return;

  // Only capture if not already set in this session (or we can overwrite if you prefer fresh attribution)
  // Standard practice is first-click or last-click. Let's do last-click for simplicity (overwrite).
  
  const urlParams = new URLSearchParams(window.location.search);
  const utm_source = urlParams.get('utm_source');
  const utm_medium = urlParams.get('utm_medium');
  const utm_campaign = urlParams.get('utm_campaign');
  const utm_term = urlParams.get('utm_term');
  const utm_content = urlParams.get('utm_content');
  const referrer = document.referrer;

  // Infer source if utm_source is missing
  let source = utm_source || '';
  if (!source && referrer) {
    if (referrer.includes('google.')) source = 'google';
    else if (referrer.includes('facebook.') || referrer.includes('fb.me')) source = 'facebook';
    else if (referrer.includes('instagram.')) source = 'instagram';
    else if (referrer.includes('bing.')) source = 'bing';
  }
  if (!source && !window.location.search) {
    source = 'direct';
  }

  const data: SourceData = {
    source: source || undefined,
    utm_source: utm_source || undefined,
    utm_medium: utm_medium || undefined,
    utm_campaign: utm_campaign || undefined,
    utm_term: utm_term || undefined,
    utm_content: utm_content || undefined,
    referrer: referrer || undefined,
  };

  // Only save if we found something useful
  if (Object.values(data).some(v => v !== undefined)) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }
}

export function getSourceData(): SourceData | null {
  if (typeof window === 'undefined') return null;
  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (!stored) return null;
  try {
    return JSON.parse(stored);
  } catch (e) {
    return null;
  }
}

export function clearSourceData() {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(STORAGE_KEY);
}
